import { Component, OnInit } from '@angular/core';
import { Transition } from '@uirouter/core';
import { OAUTH_POST_MESSAGE_NAME } from 'account-hybrid/common/constants/oauth-post-message-name.const';

@Component({
    selector: 'ft-oauth-result-view',
    templateUrl: './oauth-result-view.component.html',
    styleUrls: ['./oauth-result-view.component.scss']
})
export class OauthResultViewComponent implements OnInit {
    constructor(private transition: Transition) {
    }

    ngOnInit() {
        console.log(this.transition.params());

        if (window.opener) {
            window.opener.postMessage({
                type: OAUTH_POST_MESSAGE_NAME,
                payload: {
                    batch: this.transition.params()?.batch,
                    result: JSON.parse(this.transition.params()?.result),
                    companyUuid: this.transition.params()?.companyUuid,
                    propertyUuid: this.transition.params()?.propertyUuid
                }
            }, window.location.origin);
            window.close();
        } else {
            document.body.innerText = 'Failed to post auth result.';
        }
    }
}
